.variant {
  margin: 0;
  color: var(--ink-muted);
  font-size: 0.72em;
  text-transform: capitalize;
  transition: color 180ms ease;
}
@container panel (max-width: 13rem) {
  .variantPrefix {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .variant {
    transition: none;
  }
}
